import { FC, useEffect } from 'react';
import { AuthorizedPage, getBase, TenantLayout, Themes, useThemeContext } from '@maxtropy/components';
import { Outlet } from 'react-router-dom';

// 全屏路由出口
export const FullScreenOutlet: FC = () => {
  const { setCustomTheme } = useThemeContext();
  useEffect(() => {
    setCustomTheme?.(Themes.DARK);
    return () => {
      setCustomTheme?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
};

// 主业务页面路由出口
export const MainOutlet: FC = () => {
  // 如果是微前端，直接使用Outlet，权限和面包屑的数据由主应用提供
  if (getBase()) {
    return <Outlet />;
  }

  // 下面AuthorizedPage层提供权限校验页面，TenantLayout提供导航栏、面包屑
  return (
    <AuthorizedPage>
      <TenantLayout>
        <Outlet />
      </TenantLayout>
    </AuthorizedPage>
  );
};
